
import AjexPortalService from 'axios.js'

export const fetchWrapper = {
    get,
    post,
    put,
    delete: _delete
};

function get(url) {
    // const requestOptions = {
    //     method: 'GET'
    // };
    ;
    return AjexPortalService.get(url).then(handleResponse);
    //return AjexPortalService.get(url, requestOptions);
}

function post(url, body) {
    // const requestOptions = {
    //     method: 'POST',
    //     headers: { 'Content-Type': 'application/json' },
    //     body: JSON.stringify(body)
    // };
    //return fetch(url, requestOptions).then(handleResponse);
    return AjexPortalService.post(url, body).then(handleResponse);
}

function put(url, body) {
    // const requestOptions = {
    //     method: 'PUT',
    //     headers: { 'Content-Type': 'application/json' },
    //     body: JSON.stringify(body)
    // };
    // return fetch(url, requestOptions).then(handleResponse);    
    return AjexPortalService.put(url, body).then(handleResponse);
}

// prefixed with underscored because delete is a reserved word in javascript
function _delete(url) {
    // const requestOptions = {
    //     method: 'DELETE'
    // };
    // return fetch(url, requestOptions).then(handleResponse);
    return AjexPortalService.delete(url).then(handleResponse);
}

// helper functions

function handleResponse(response) {

    if (response === undefined) {
        return null;
    }
    if (response.data.data === undefined) {
        ;
        return response.data;
    }
    else

        return response.data.data;
    // return response.text().then(text => {
    //     ;
    //     const data = text && JSON.parse(text);
    //     ;
    //     if (!response.ok) {
    //         const error = (data && data.message) || response.statusText;
    //         return Promise.reject(error);
    //     }

    //     return data;
    // });
}